import styled from "styled-components";

const TablePaper = styled.div`
    padding: 1.5rem 3.5rem 1rem 3.5rem;
    box-shadow: 0px 3px 1px -2px ${(props) => props.theme.colors.black(0.2)}, 0px 2px 2px 0px ${(props) => props.theme.colors.black(0.14)},
        0px 1px 5px 0px ${(props) => props.theme.colors.black(0.12)};
    background-color: ${(props) => props.theme.colors.white(1)};
    min-height: 20rem;
    position: relative;
    @media print {
        padding: 0 0 10rem 0;
        min-height: 0;
        box-shadow: none;
    }
`;

export default TablePaper;
